import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useSizesSection} from '../useGetProductBulkSection';
import {
  AvailabilitySectionView,
  AvailabilitySectionViewProps,
} from './AvailabilitySectionView';

export const AvailabilitySection: React.FC<
  Pick<AvailabilitySectionViewProps, 'selectedSize'>
> = props => {
  return (
    <DataFetcher
      request={useSizesSection()}
      Error={null}
      View={({sizeSelection, ...viewProps}) => (
        <AvailabilitySectionView
          defaultHint={sizeSelection.defaultLowStockHint}
          {...viewProps}
        />
      )}
      viewProps={props}
    />
  );
};
